import React from 'react';
import './Footer.css';
import kakaoQr from '../images/KakaoTalk_code.jpg';

const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer-inner">
				{/* 상단: 고객센터 + 카카오톡 QR */}
				<div className="footer-top">
					<div className="footer-cs">
						<h3>고객센터</h3>
						<p className="cs-phone">📞 010-9145-2612</p>
						<div className="cs-buttons">
							<a 
								href="https://open.kakao.com/o/sJ2m9h3h" 
								target="_blank" 
								rel="noopener noreferrer"
								className="kakao-btn"
							>
								<img src="/images/kakao-icon.png" alt="카카오톡" />
								카카오톡 상담
							</a>
							<a href="/inquiry" className="inquiry-btn">
								1:1 문의하기
							</a>
						</div>
						<p className="cs-info">
							평일 10:00 - 18:00 (점심 12:00-13:00)<br/>
							토/일/공휴일 휴무
						</p>
					</div>

					<div className="footer-qr">
						<img src={kakaoQr} alt="카카오톡 QR" />
						<p>카카오톡 채널 추가</p>
					</div>
				</div>

				{/* 중단: 배송/교환/반품 안내 */}
				<div className="footer-policy">
					<div className="policy-section">
						<h4>📦 배송 안내</h4>
						<ul>
							<li><strong>배송 기간:</strong> 주문 후 7~14일 (구매대행 특성상 변동 가능)</li>
							<li><strong>배송비:</strong> 무료</li>
							<li><strong>관세 안내:</strong></li>
							<li className="tax-notice">
								· 미국: $200 초과 시 관세 구매자 부담<br/>
								· 기타 국가: $150 초과 시 관세 구매자 부담
							</li>
							<li>도서산간 지역 추가 비용 없음</li>
						</ul>
					</div>

					<div className="policy-section">
						<h4>🔄 교환/반품 안내</h4>
						<ul>
							<li><strong>신청 기간:</strong> 제품 수령 후 7일 이내</li>
							<li><strong>교환/반품 비용:</strong></li>
							<li className="return-cost">
								· 단순 변심: 왕복 배송비 고객 부담 (5만원이하 - 30,000원, 5만원 이상 - 60,000원)<br/>
								· 상품 하자: 무료 교환/반품
							</li>
							<li><strong>불가 사유:</strong></li>
							<li className="return-limit">
								· 착용/세탁한 상품<br/>
								· 택(TAG) 제거 또는 훼손<br/>
								· 구매자 단순 변심 (해외 구매대행 특성)
							</li>
						</ul>
					</div>
				</div>

				{/* 하단: 회사 정보 - 필수정보 6가지 모두 포함 */}
				<div className="footer-bottom">
					<div className="company-info">
						<p className="company-name">wearToday</p>
						<p>
							<strong>상호:</strong> 지티마켓 | 
							<strong>대표자:</strong> 한용수
						</p>
						<p>
							<strong>사업자등록번호:</strong> 165-17-02491 | 
							<strong>통신판매업신고:</strong> 2025-수원장안-0904
						</p>
						<p>
							<strong>주소:</strong> 경기도 수원시 장안구 이목로24
						</p>
						<p>
							<strong>고객센터:</strong> 010-9145-2612 | 
							<strong>이메일:</strong> cozip99@naver.com
						</p>
					</div>

					<div className="footer-links">
						<a href="/terms">이용약관</a>
						<a href="/privacy" className="highlight">개인정보처리방침</a>
						<a href="https://www.ftc.go.kr/bizCommPop.do?wrkr_no=1651702491" target="_blank" rel="noopener noreferrer">사업자정보확인</a>
					</div>

					<div className="footer-notice">
						<p>
							※ wearToday는 해외 구매대행 서비스로, 상품 주문 후 해외에서 직접 구매하여 배송합니다.<br/>
							※ 배송 기간은 현지 사정에 따라 7~14일 소요되며, 천재지변 등 예외 상황 시 지연될 수 있습니다.<br/>
							※ 관세법에 따라 일정 금액 초과 시 관세가 부과되며, 이는 구매자 부담입니다.
						</p>
					</div>

					<p className="copyright">
						© 2025 wearToday. All rights reserved.
					</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
